import { Box, Flex, Text, Button } from '@chakra-ui/react'
import React from 'react'

interface CardTopProps {
  icon?: any;
  title: string,
  subTitle?: string,
  textButton?: string,
  onOpen?: () => void,
  [rest: string]: any;
}

const CardTop : React.FC<CardTopProps> = ({title, subTitle, textButton, icon, onOpen, ...rest}) => (
  <Flex borderRadius='12px' bg='tertiary.30' justifyContent='space-between' alignItems='center' p='24px' mb='40px' {...rest}>
    <Flex maxW='825px' alignItems='center'>
      <Box pr='20px'>
        {icon}
      </Box>
      <Box>
        <Text textStyle='h6' pb='8px'>{title}</Text>
        { subTitle && <Text textStyle='bodyMd'>{subTitle}</Text> }
      </Box>
    </Flex>
    {
      textButton && 
      <Box>
        <Button onClick={onOpen} data-testid='send-request-top'>{textButton}</Button>
      </Box>
    }
  </Flex>
)

export default CardTop
